
export const historyDataParameters = Object.freeze({
  vitals: [
    'Height',
    'Weight',
    'Body Mass Index',
    'Temperature',
    'Oxygen',
    'Heart Rate',
    'Blood Pressure',
    'Respiratory Rate',
    "Smoking Cessation",
    "Alcohol Cessation"
  ],
});
